import { render } from "./CharacterItem.vue?vue&type=template&id=0da68d6e"
import script from "./CharacterItem.vue?vue&type=script&lang=js"
export * from "./CharacterItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__